module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.unprocessed'))), _c('b', [_vm._v(_vm._s(_vm.unread))]), _vm._v(_vm._s(_vm.$t('word.item')) + "/" + _vm._s(_vm.$t('word.total')) + _vm._s(_vm.pager.total) + _vm._s(_vm.$t('word.item')))])])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_vm._l((_vm.absenceList), function(item) {
    return _c('div', {
      staticClass: "listItem"
    }, [_c('div', {
      staticClass: "item-first-row"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.offWorker')) + "："), _c('b', {
      staticClass: "user"
    }, [_vm._v(_vm._s(item.originateUserName))])]), _c('span', [_vm._v(_vm._s(_vm.$t('word.suspendWork')) + "："), _c('b', {
      staticClass: "book"
    }, [_vm._v("《" + _vm._s(item.requirementName) + "》")])])]), _vm._v(" "), _c('div', {
      staticClass: "item-second-row"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.suspendTime')) + "：" + _vm._s(_vm.$t('word.from')) + " "), _c('b', [_vm._v(_vm._s(_vm.getFormatDate(item.startTime)))]), _vm._v(" " + _vm._s(_vm.$t('word.to')) + " "), _c('b', [_vm._v(_vm._s(_vm.getFormatDate(item.endTime)))]), _vm._v(" " + _vm._s(_vm.$tc('word.total')) + " "), _c('b', [_vm._v(_vm._s(_vm.getDiffDays(item.startTime, item.endTime)))]), _vm._v(" " + _vm._s(_vm.$t('word.day')))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.handleAbsence(item.id)
        }
      }
    }, [(item.status === 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('comb.handle')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('word.check')))])])], 1)])
  }), _vm._v(" "), _c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.pager.total,
      "size": "pager.size",
      "current-page": _vm.pager.currentPage
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 2)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "multiAuditOnLeave",
      "custom-class": "detailDialog",
      "size": "small"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.offWorker')) + "：" + _vm._s(_vm.detail.anchor))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('word.suspendWork')) + "： " + _vm._s(_vm.detail.workName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('word.suspendTime')) + "： " + _vm._s(_vm.$t('word.from')) + _vm._s(_vm.detail.startDate) + _vm._s(_vm.$t('word.to')) + _vm._s(_vm.detail.endDate) + " " + _vm._s(_vm.$t('word.total')) + _vm._s(_vm.detail.duration) + _vm._s(_vm.$tc('word.day')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('comb.additionalRemarks')) + "： " + _vm._s(_vm.detail.description))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('comb.commitTime')) + "： " + _vm._s(_vm.detail.commitTime))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('word.status')) + "：" + _vm._s(_vm.detail.statusLabel))]), _vm._v(" "), (_vm.detail.status === 1) ? _c('div', {
    staticClass: "buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.agree
    }
  }, [_vm._v(_vm._s(_vm.$t('word.agree')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.disagree
    }
  }, [_vm._v(_vm._s(_vm.$t('word.refuse')))])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a81305f4!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/center/Events.vue
// module id = 1032
// module chunks = 0